import { Bird, BookOpenCheck, Boxes, BriefcaseBusiness, Building2, ChartColumn, HandCoins, Home, MapPin, MessageSquareWarning, Package, Settings2, ShieldCheck, ShoppingCart, Target, Truck, Upload, UserRound, Wheat, type LucideIcon } from 'lucide-react';

export interface NavItem {
  to: string;
  icon: LucideIcon;
  labelKey: string;
  /** Entrée visible seulement avec cette permission (`admin` : l'un des onglets du hub). */
  permission?: string;
  /** Permissions exigées en plus (toutes). */
  allOf?: string[];
  /** Permissions dont l'une au moins est exigée en plus. */
  anyOf?: string[];
  soon?: boolean;
}

export const MAIN_NAV: NavItem[] = [
  { to: '/', icon: Home, labelKey: 'nav.home' },
  { to: '/comptes', icon: Building2, labelKey: 'nav.accounts', permission: 'accounts.read' },
  { to: '/pipeline', icon: BriefcaseBusiness, labelKey: 'nav.pipeline', permission: 'pipeline.read' },
  { to: '/visites', icon: MapPin, labelKey: 'nav.visits', permission: 'visits.read' },
  { to: '/stock', icon: Boxes, labelKey: 'nav.stock', permission: 'stock.read' },
  { to: '/ventes', icon: ShoppingCart, labelKey: 'nav.sales', permission: 'sales.read' },
  { to: '/encaissements', icon: HandCoins, labelKey: 'nav.receivables', permission: 'receivables.read' },
  // Objectifs et prévisions : visible avec l'une des permissions du module (contrat objectifs § 8).
  { to: '/objectifs', icon: Target, labelKey: 'nav.performance', anyOf: ['targets.read', 'team_performance.read', 'targets.write', 'forecasts.write', 'forecasts.approve'] },
  { to: '/reclamations', icon: MessageSquareWarning, labelKey: 'nav.complaints', permission: 'complaints.read' },
  { to: '/elevage', icon: Bird, labelKey: 'nav.livestock', permission: 'livestock.read' },
  { to: '/logistique', icon: Truck, labelKey: 'nav.logistics', permission: 'logistics.read' },
  { to: '/qualite', icon: ShieldCheck, labelKey: 'nav.quality', permission: 'quality.read' },
  { to: '/meunerie', icon: Wheat, labelKey: 'nav.milling', permission: 'milling.read' },
  { to: '/analyses', icon: ChartColumn, labelKey: 'nav.analytics', permission: 'analytics.read' },
  { to: '/catalogue', icon: Package, labelKey: 'nav.catalog', permission: 'catalog.read' },
  // L'import écrit des comptes, des articles, des prix, des créances de l'ERP ou des objectifs : il faut aussi le droit de gérer l'un d'eux.
  { to: '/import', icon: Upload, labelKey: 'nav.imports', permission: 'imports.run', anyOf: ['accounts.write', 'catalog.write', 'pricing.write', 'receivables.import', 'targets.write'] },
];

/** Entrée unique « Administration » : visible si l'un des onglets du hub l'est (`admin/tabs.ts`). */
export const ADMIN_NAV: NavItem[] = [
  { to: '/admin', icon: Settings2, labelKey: 'nav.administration', permission: 'admin' },
  { to: '/aide', icon: BookOpenCheck, labelKey: 'nav.help' },
];

export const BOTTOM_NAV: NavItem[] = [
  { to: '/', icon: Home, labelKey: 'nav.home' },
  { to: '/comptes', icon: Building2, labelKey: 'nav.accounts', permission: 'accounts.read' },
  { to: '/visites', icon: MapPin, labelKey: 'nav.visits', permission: 'visits.read' },
  { to: '/ventes', icon: ShoppingCart, labelKey: 'nav.sales', permission: 'sales.read' },
  { to: '/compte', icon: UserRound, labelKey: 'nav.myAccount' },
];

/** Entrées autorisées pour la personne (les entrées « bientôt » restent visibles, désactivées). */
export function allowedNav(items: NavItem[], can: (p: string) => boolean): NavItem[] {
  return items.filter((i) => (!i.permission || i.permission === 'admin' || can(i.permission)) && (i.allOf ?? []).every(can) && (!i.anyOf || i.anyOf.some(can)));
}
